import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  message: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    forgotPassword(state, action) {
      state.loading = true;
      state.error = null;
    },
    forgotPasswordSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.message =
        "An email is sent with Password Reset Link. Please check your email to continue.";
    },
    forgotPasswordFailure(state, action) {
      state.loading = false;
      state.error = action.payload.message;
    },
    initializeMessage(state, action) {
      state.message = null;
    },
    initializeError(state, action) {
      state.error = null;
    },
  },
});

export const { actions, reducer, name: sliceKey } = forgotPasswordSlice;
